import React, { Component } from 'react';
import { Row, Col, Input, Form, FormGroup, Table, Label } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class MorningBandwidth2 extends Component {
    constructor(props) {
        super(props);
        this.selectorArr = this.props.selector != null && this.props.selector !== '' ? this.props.selector.split('/') : [];
        this.state = {
            data: [],
            sheetData: [],
            selectedEmployee: this.selectorArr.length > 0 && this.selectorArr[0] != null ? parseInt(this.selectorArr[0]) : 0,
            selectedTeam: this.selectorArr.length > 1 && this.selectorArr[1] != null ? parseInt(this.selectorArr[1]) : 0,
            selectedDepartment: this.selectorArr.length > 2 && this.selectorArr[2] != null ? parseInt(this.selectorArr[2]) : 0,
            windowStartTime: this.selectorArr.length > 3 && this.selectorArr[3] != null ? (this.selectorArr[3]) : "07:00",
            windowEndTime: this.selectorArr.length > 4 && this.selectorArr[4] != null ? (this.selectorArr[4]) : "09:00",
            defaultDeliveryTime: this.selectorArr.length > 5 && this.selectorArr[5] != null ? (this.selectorArr[5]) : "09:30",
        };
        this.columns = ['Employee', 'Departments', 'Team', 'Start Date', 'Position', 'Role', 'Employee Start Time', 'Employee End Time', 'Employee Capacity', 'Assigned to Employee', 'Employee Availability', 'Workflow Target Time', 'Workflow Target Employee Availability', 'Notes']
    }

    componentDidMount() {
        this.props.log('MorningBandwidth.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('MorningBandwidth.js/onSubmit');
        fetch('/api/reports/MorningBandwidth2', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let data = results.data.map(d => {
                        return {
                            ...d,
                            clients: JSON.stringify(d.clients) !== '[{}]' ? 
                                d.clients.filter(client => client.workflows != null).map(client => {
                                    return {
                                        ...client
                                        ,workflows: client.workflows.filter(workflow => workflow.workflowId != null).map(workflow => {
                                            return {
                                                ...workflow,
                                                workflowEstimates: JSON.stringify(workflow.workflowEstimates) !== '[{}]' ? workflow.workflowEstimates : null,
                                                workflowTaskEstimates: JSON.stringify(workflow.workflowTaskEstimates) !== '[{}]' ? workflow.workflowTaskEstimates : null
                                            }
                                        })
                                    }
                                })
                            : null,
                            departments: JSON.stringify(d.departments) !== '[{}]' ? d.departments : null,
                        }
                    });
                    this.setState({
                        data: this.processData(data),
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    processData = (data) => {
        this.props.log('MorningBandwidth.js/processData (data)', data);
        data = data.map(item => {
            let employeeWorkflowEstimateTotal = 0;
            let employeeWorkflowTaskEstimateTotal = 0;
            if (item.clients != null) {
                item.clients.forEach(client => {
                    if (client.workflows != null) {
                        let clientWorkflowEstimateTotal = 0;
                        let clientWorkflowTaskEstimateTotal = 0;
                        client.workflows.forEach(wft => {
                            if (wft.workflowEstimates != null) {
                                wft.workflowEstimates.forEach(workflowEstimate => {
                                    if (workflowEstimate.duration != null) {
                                        clientWorkflowEstimateTotal += workflowEstimate.duration;
                                    }
                                })
                            }
                            if (wft.workflowTaskEstimates != null && clientWorkflowEstimateTotal === 0) {
                                wft.workflowTaskEstimates.forEach(workflowTaskEstimate => {
                                    if (workflowTaskEstimate.duration != null) {
                                        clientWorkflowTaskEstimateTotal += workflowTaskEstimate.duration;
                                    }
                                })
                            }
                        })
                        employeeWorkflowEstimateTotal += clientWorkflowEstimateTotal;
                        employeeWorkflowTaskEstimateTotal += clientWorkflowTaskEstimateTotal;
                    }
                })
            }
            const capacity = this.getCapacity(item.startTime, this.state.defaultDeliveryTime);
            return {
                ...item,
                startDate: String(item.startDate).indexOf('-') > -1 ? this.formatDate(item.startDate) : item.startDate,
                startTimePreformatted: item.startTime,
                startTime: String(item.startTime).indexOf('m') === -1 ? this.getTime(item.startTime) : item.startTime,
                endTimePreformatted: item.endTime,
                endTime: String(item.endTime).indexOf('m') === -1 ? this.getTime(item.endTime) : item.endTime,
                assigned: employeeWorkflowEstimateTotal + employeeWorkflowTaskEstimateTotal,
                availability: parseFloat(capacity) - (employeeWorkflowEstimateTotal + employeeWorkflowTaskEstimateTotal),
                capacity: capacity
            }
        })
        return data;
    }

    formatDate = (d) => {
        this.props.info('MorningBandwidth.js/formatDate (d)', d);
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    calculateWorkflowTargetTime = (clients) => {
        this.props.info('MorningBandwidth.js/calculateWorkflowTargetTime (clients)', clients);
        let val = 0;
        clients != null && clients.forEach(client => {
            client.workflows != null && client.workflows.forEach(workflow => {
                workflow.workflowEstimates != null && workflow.workflowEstimates.forEach(wfEstimate => {
                    val += wfEstimate.timeTarget;
                })
            });
        })
        if (isNaN(val)) val = 0;
        return val;
    }

    calculateWorkflowAvailability = (startTime, clients) => {
        this.props.info('MorningBandwidth.js/calculateWorkflowAvailability (startTime, clients)', startTime, clients);
        // if (startTime == null || startTime === '' || this.calculateWorkflowTargetTime(clients) === 0) return 0;
        return this.getCapacity(startTime, this.state.defaultDeliveryTime) - this.calculateWorkflowTargetTime(clients);
    }

    getCapacity = (t1, t2) => {
        this.props.info('MorningBandwidth.js/getCapacity (t1, t2)', t1, t2);
        if (t1 === '' || t2 === '') return null;
        if (t1 == null || t2 == null) return null;
        return (0.5 * Math.round(
            (0 + (parseInt(this.minuteDifference(t1, t2)) / 60)) +
            Math.abs(0 - parseInt(this.minuteDifference(t1, t2)) / 60)
        ))
    }

    minuteDifference = (t1, t2) => {
        this.props.info('MorningBandwidth.js/minuteDifference (t1, t2)', t1, t2);
        return Math.floor((Math.abs(new Date('2000/01/01 ' + t1) - new Date('2000/01/01 ' + t2)) / 1000) / 60);
    }

    getTime = (time) => {
        this.props.info('MorningBandwidth.js/getTime (time)', time);
        if (time == null || time === '') return '';
        var hours = parseInt(time.substring(0, 2)),
            minutes = parseInt(time.substring(3, 5)),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + String(minutes).padStart(2, '0') + ' ' + ampm;
    }

    onChange = (e) => {
        this.props.log('MorningBandwidth.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.setState({
            [e.target.name]: (e.target.name === 'windowStartTime' || e.target.name === 'windowEndTime') || e.target.name === 'defaultDeliveryTime' ? e.target.value : parseInt(e.target.value),
        }, () => {
            if (e.target.name === 'defaultDeliveryTime') this.setState({ data: this.processData(this.state.data) });
            this.props.changeSelector({
                target: {
                    value: String((this.state.selectedEmployee) + '/' + (this.state.selectedTeam) + '/' + (this.state.selectedDepartment) + '/' + this.state.windowStartTime + '/' + this.state.windowEndTime + '/' + this.state.defaultDeliveryTime).replace('0/0/0/07:00/09:00/09:30', '')
                }
            });
            this.getCSVdata();
        }
        );
    }

    formatNegPos = (num) => {
        this.props.info('MorningBandwidth.js/formatNegPos (num)', num);
        if (num > 0) return Number(num).toFixed(2) + ' h';
        return '(' + Number(num).toFixed(2) + ' h)'
    }

    getCSVdata = () => {
        this.props.log('MorningBandwidth.js/getCSVdata');
        const filteredArray = this.state.data
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || parseInt(this.state.selectedEmployee) === parseInt(employee.employeeId))
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || parseInt(this.state.selectedTeam) === parseInt(employee.teamId))
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.departments != null && employee.departments.length > 0 && employee.departments.findIndex(department => department.id === this.state.selectedDepartment)) > -1);
        const totalAvailability = filteredArray.reduce((prev, cur) => prev + (!isNaN(cur.availability) ? cur.availability : 0), 0);
        let retArr = [[
            'Employee: ',
            'Team: ',
            'Department: ',
            'Window Start Time',
            'Window End Time',
            'Default Delivery Time'
        ],
        [
            document.getElementById('selectedEmployee').options[document.getElementById('selectedEmployee').selectedIndex].text,
            document.getElementById('selectedTeam').options[document.getElementById('selectedTeam').selectedIndex].text,
            document.getElementById('selectedDepartment').options[document.getElementById('selectedDepartment').selectedIndex].text,
            document.getElementById('windowStartTime').value,
            document.getElementById('windowEndTime').value,
            document.getElementById('defaultDeliveryTime').value,
        ],
        [], this.columns];
        retArr = retArr.concat(this.state.data
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || this.state.selectedEmployee === employee.employeeId)
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || this.state.selectedTeam === employee.teamId)
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.departments != null && employee.departments.findIndex(department => department.id === this.state.selectedDepartment)) > -1)
            .map(employee => ([
                employee.lastName + ', ' + employee.firstName,
                employee.departments != null && employee.departments.length > 0 ? [...employee.departments].map(department => department.departmentName).join(', ') : '',
                employee.team,
                employee.startDate,
                employee.jobTitle,
                employee.role1,
                employee.startTime,
                employee.endTime,
                this.getCapacity(employee.startTime, this.state.defaultDeliveryTime) > 0 ? this.getCapacity(employee.startTime, this.state.defaultDeliveryTime) : '',
                employee.assigned > 0 ? employee.assigned : '',
                employee.availability !== 0 && !isNaN(employee.availability) ? employee.availability : '',
                this.calculateWorkflowTargetTime(employee.clients) > 0 ? this.calculateWorkflowTargetTime(employee.clients) : '',
                this.calculateWorkflowAvailability(employee.startTime, employee.clients) !== 0 ? this.calculateWorkflowAvailability(employee.startTime, employee.clients) : '',
                this.parseNotes(employee)
            ]
            )))
        retArr.push([
            'Totals', '', '', '', '', '', '', '',
            filteredArray.reduce((prev, cur) => prev + this.getCapacity(cur.startTime, this.state.defaultDeliveryTime), 0),
            filteredArray.reduce((prev, cur) => prev + cur.assigned, 0),
            totalAvailability !== 0 && !isNaN(totalAvailability) ? totalAvailability : '--',
            filteredArray.reduce((prev, cur) => prev + this.calculateWorkflowTargetTime(cur.clients), 0),
            filteredArray.reduce((prev, cur) => prev + this.calculateWorkflowAvailability(cur.startTime, cur.clients), 0)
        ])
        this.props.passData(retArr, "morning-bandwidth");
    }

    parseNotes = (employee) => {
        this.props.info('MorningBandwidth.js/parseNotes (employee)', employee);
        let arr = [];
        if (employee.clients == null) return '';
        let assigned = 0;
        employee.clients.filter(client => client.workflows != null).forEach(client => {
            let clientStr = client.name;
            client.workflows.filter(workflow => workflow.workflowEstimates != null
                && workflow.workflowEstimates.length > 0
                && workflow.workflowEstimates[0].begin != null
                && workflow.workflowEstimates[0].end != null
            ).forEach(workflow => {
                let didStartBeforeWindow = workflow.workflowEstimates[0].begin < this.state.windowStartTime;
                let didFinishAfterWindow = workflow.workflowEstimates[0].end > this.state.windowEndTime;
                let didStartAfterWindow = workflow.workflowEstimates[0].begin > this.state.windowEndTime;
                let didFinishBeforeWindow = workflow.workflowEstimates[0].end < this.state.windowStartTime;
                // let assigned = 0;
                clientStr += ' - ' + this.getTime(workflow.workflowEstimates[0].begin) + ' to ' + this.getTime(workflow.workflowEstimates[0].end);
                if (didStartBeforeWindow && !didFinishAfterWindow && !didStartAfterWindow && !didFinishBeforeWindow) {
                    clientStr += ' - Assigned Process starting before window';
                    assigned += (this.timeDiff(this.state.windowStartTime, this.state.windowEndTime) - this.timeDiff(this.state.windowStartTime, workflow.workflowEstimates[0].begin));
                }
                if (didStartBeforeWindow && didFinishAfterWindow && !didStartAfterWindow && !didFinishBeforeWindow) {
                    clientStr += ' - Assigned Process starts and ends outside window';
                    assigned += this.timeDiff(this.state.windowStartTime, this.state.windowEndTime);
                }
                if ((didStartBeforeWindow && didFinishBeforeWindow) || (didStartAfterWindow && didFinishAfterWindow)) {
                    clientStr += ' - Assigned Process is outside window';
                    assigned += this.timeDiff(this.state.windowStartTime, this.state.windowEndTime);
                }
                if (!didStartBeforeWindow && !didFinishAfterWindow && !didStartAfterWindow && !didFinishBeforeWindow) {
                    assigned += this.timeDiff(workflow.workflowEstimates[0].start, workflow.workflowEstimates[0].end);
                }
                if (!didStartBeforeWindow && didFinishAfterWindow && !didStartAfterWindow && !didFinishBeforeWindow) {
                    clientStr += ' - Assigned Process ending after window';
                    assigned += (this.timeDiff(this.state.windowStartTime, this.state.windowEndTime) - this.timeDiff(this.state.windowEndTime, workflow.workflowEstimates[0].end));
                }
            })
            arr.push(clientStr);
        })
        if (assigned > 0) arr.push('Total Assigned - ' + Number(assigned).toFixed(2) + ' hour' + (assigned === 1 ? '' : 's'));
        return arr.join(' | ');
    }

    timeDiff = (start, end) => {
        this.props.info('MorningBandwidth.js/timeDiff (start, end)', start, end);
        if (start == null || end == null) return 0;
        let d1 = new Date(1970, 1, 1, parseInt(start.substring(0, 2)), parseInt(start.substring(3, 5)))
        let d2 = new Date(1970, 1, 1, parseInt(end.substring(0, 2)), parseInt(end.substring(3, 5)))
        let diff = Math.abs(d1.getTime() - d2.getTime());
        let hours = diff / 1000 / 60 / 60;
        return hours;
    }

    render() {
        this.props.info('MorningBandwidth.js/render');
        const filteredArray = this.state.data
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || parseInt(this.state.selectedEmployee) === parseInt(employee.employeeId))
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || parseInt(this.state.selectedTeam) === parseInt(employee.teamId))
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.departments != null && employee.departments.length > 0 && employee.departments.findIndex(department => department.id === this.state.selectedDepartment)) > -1);
        const totalAvailability = filteredArray.reduce((prev, cur) => prev + (!isNaN(cur.availability) ? cur.availability : 0), 0);
        return (
            <>
                <Row className="mt-4">
                    <Col>
                        <Form inline>
                            <FormGroup className='mr-2'>
                                <Input type="select"
                                    name="selectedEmployee"
                                    id="selectedEmployee"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedEmployee)}
                                >
                                    <option value="0">ALL EMPLOYEES</option>
                                    {
                                        this.state.data.map(employee => (
                                            <option
                                                key={"employee_" + employee.employeeId}
                                                value={this.props.isFieldNull(employee.employeeId)}
                                            >{employee.lastName + ', ' + employee.firstName}</option>
                                        ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mr-2'>
                                <Input type="select"
                                    name="selectedTeam"
                                    id="selectedTeam"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedTeam)}
                                >
                                    <option value="0">ALL TEAMS</option>
                                    {
                                        [...new Set(
                                            [...this.state.data]
                                                .map(employee => { return JSON.stringify({ team: employee.team, teamId: employee.teamId }) })
                                        )].map(team => JSON.parse(team))
                                            .sort((a, b) => a.team.localeCompare(b.team))
                                            .map(team => (
                                                <option
                                                    key={"team_" + team.teamId}
                                                    value={this.props.isFieldNull(team.teamId)}
                                                >{team.team}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mr-2'>
                                <Input type="select"
                                    name="selectedDepartment"
                                    id="selectedDepartment"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedDepartment)}
                                >
                                    <option value="0">ALL DEPARTMENTS</option>
                                    {
                                        [...new Set(
                                            [...this.state.data]
                                                .filter(employee => employee.departments != null)
                                                .map(employee => employee.departments).flat()
                                                .map(departments => { return JSON.stringify({ id: departments.id, departmentName: departments.departmentName }) })
                                        )]
                                            .map(department => JSON.parse(department))
                                            .sort((a, b) => a.departmentName.localeCompare(b.departmentName))
                                            .map(department => (
                                                <option
                                                    key={"department_" + department.id}
                                                    value={this.props.isFieldNull(department.id)}
                                                >{department.departmentName}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mx-2'>
                                <Label>Window Start Time

                                    <Input type="time"
                                        className='ml-2'
                                        name="windowStartTime"
                                        id="windowStartTime"
                                        onChange={(e) => this.onChange(e)}
                                        value={this.props.isFieldNull(this.state.windowStartTime)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup className='mx-2'>
                                <Label>Window End Time

                                    <Input type="time"
                                        className='ml-2'
                                        name="windowEndTime"
                                        id="windowEndTime"
                                        onChange={(e) => this.onChange(e)}
                                        value={this.props.isFieldNull(this.state.windowEndTime)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup className='mx-2'>
                                <Label>Default Delivery Time

                                    <Input type="time"
                                        className='ml-2'
                                        name="defaultDeliveryTime"
                                        id="defaultDeliveryTime"
                                        onChange={(e) => this.onChange(e)}
                                        value={this.props.isFieldNull(this.state.defaultDeliveryTime)}
                                    />
                                </Label>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
                <Table className='mt-3'>
                    <thead>
                        <tr>
                            {this.columns.map(col => (
                                <th key={col} className="wrap">{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredArray.map(employee => (
                            <tr key={employee.employeeId}>
                                <td>{employee.lastName}, {employee.firstName}</td>
                                <td>{employee.departments != null && employee.departments.length > 0 ? [...employee.departments].map(department => department.departmentName).join(', ') : ''}</td>
                                <td>{employee.team}</td>
                                <td>{employee.startDate}</td>
                                <td>{employee.jobTitle}</td>
                                <td>{employee.role1}</td>
                                <td>{employee.startTime}</td>
                                <td>{employee.endTime}</td>
                                <td>{this.getCapacity(employee.startTime, this.state.defaultDeliveryTime) > 0 ? this.getCapacity(employee.startTime, this.state.defaultDeliveryTime) + ' h' : '--'}</td>
                                <td>{employee.assigned > 0 ? employee.assigned + ' h' : '--'}</td>
                                <td>{employee.availability !== 0 && !isNaN(employee.availability) ? this.formatNegPos(employee.availability) : '--'}</td>
                                <td>{this.calculateWorkflowTargetTime(employee.clients) > 0 ? this.calculateWorkflowTargetTime(employee.clients) + ' h' : '--'}</td>
                                <td>{this.calculateWorkflowAvailability(employee.startTime, employee.clients) !== 0 ? this.formatNegPos(this.calculateWorkflowAvailability(employee.startTime, employee.clients)) : '--'}</td>
                                <td>{this.parseNotes(employee)}</td>
                            </tr>
                        ))
                        }
                    </tbody>
                    <tfoot>
                        <tr className='font-weight-bold'>
                            <td>Totals</td>
                            <td colSpan={7}></td>
                            <td>{Number(filteredArray.reduce((prev, cur) => prev + this.getCapacity(cur.startTime, this.state.defaultDeliveryTime), 0)).toFixed(2)} h</td>
                            <td>{Number(filteredArray.reduce((prev, cur) => prev + cur.assigned, 0)).toFixed(2)} h</td>
                            <td>{totalAvailability !== 0 && !isNaN(totalAvailability) ? this.formatNegPos(totalAvailability) : '--'}</td>
                            <td>{Number(filteredArray.reduce((prev, cur) => prev + this.calculateWorkflowTargetTime(cur.clients), 0)).toFixed(2)} h</td>
                            <td>{Number(filteredArray.reduce((prev, cur) => prev + this.calculateWorkflowAvailability(cur.startTime, cur.clients), 0)).toFixed(2)} h</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </Table>
            </>
        );

    }
}

export default MorningBandwidth2;
